import app from 'flarum/forum/app';
import NotificationsDropdown from 'flarum/forum/components/NotificationsDropdown';
import ErasureRequestsList from './ErasureRequestsList';
export default class ErasureRequestsDropdown extends NotificationsDropdown {
  static initAttrs(attrs) {
    attrs.label = attrs.label || app.translator.trans('flarum-gdpr.forum.erasure_requests.tooltip');
    attrs.icon = attrs.icon || 'fas fa-user-minus';
    super.initAttrs(attrs);
  }
  getContent() {
    return m(ErasureRequestsList, {
      state: this.attrs.state
    });
  }
  goToRoute() {
    m.route.set(app.route('erasure-requests'));
  }
  getUnreadCount() {
    if (!this.attrs.state.hasItems()) {
      return app.forum.attribute('erasureRequestCount');
    }
    return app.store.all('erasure-requests').length;
  }
  getNewCount() {
    return this.getUnreadCount();
  }
}
flarum.reg.add('flarum-gdpr', 'forum/components/ErasureRequestsDropdown', ErasureRequestsDropdown);